import { network } from 'services/network';

import { QueryParams } from 'api/queries/getVersionListByContractId.query';

export const getVersionDetails = (params: QueryParams | { hashList: string[] }) => {
    return network.post('api/bo/getVersionDetails', params).then((response) => response.data);
};
